import { digitalContractsService } from '../services/api';
import { mensagemDoErroDeCarga } from '../design';

/**
 * O contrato digital ASSINADO de uma proposta, para virar anexo da assinatura criada a partir dela (08/10/2026).
 *
 * Criar a assinatura a partir da proposta existe em DOIS lugares (a aba de propostas do lead e o "Sim, criar
 * assinatura" da proposta ganha, no App), e os dois liam o contrato digital com o mesmo catch: a leitura que falhava
 * virava "Nenhum contrato digital encontrado", e a assinatura era GRAVADA sem o PDF assinado (e, na aba, como
 * Rascunho), com a tela dizendo "sucesso". Agora os dois passam por aqui, e "não consegui ler" não é "não há".
 */
export type LeituraDoContratoDigital =
  | { lido: true; anexo: Record<string, any> | null }
  | { lido: false; motivo: string };

export async function lerContratoDigitalAssinado(proposal: { id: number; code: string }): Promise<LeituraDoContratoDigital> {
  let digitalContracts: any;
  try {
    digitalContracts = await digitalContractsService.getByProposal(proposal.id);
  } catch (e) {
    return { lido: false, motivo: mensagemDoErroDeCarga(e) };
  }
  if (!Array.isArray(digitalContracts)) return { lido: false, motivo: 'a resposta não veio como lista' };
  const assinado = digitalContracts.find((dc: any) => dc.status === 'Assinado' && dc.signedPdfUrl);
  if (!assinado) return { lido: true, anexo: null };
  return {
    lido: true,
    anexo: {
      id: `dc-${assinado.id}`,
      filename: `contrato_${proposal.code}_assinado.pdf`,
      originalName: `Contrato Digital ${proposal.code} - Assinado.pdf`,
      mimeType: 'application/pdf',
      size: 0,
      uploadedAt: new Date().toISOString(),
      description: `Contrato digital assinado via ClickSign em ${new Date(assinado.signedAt).toLocaleDateString('pt-BR', { timeZone: 'America/Sao_Paulo' })}`,
      s3Key: assinado.signedPdfUrl,
    },
  };
}

/** A recusa, nas mesmas palavras nos dois lugares. */
export const recusaSemContratoDigital = (codigo: string, motivo: string) =>
  `Não criei a assinatura: não consegui ler o contrato digital da proposta ${codigo} (${motivo}). `
  + 'Sem essa leitura, a assinatura nasceria sem o PDF assinado, mesmo que o cliente já tenha assinado. '
  + 'Nada foi gravado. Tente de novo.';
